import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { FooterFull } from "../../../components/FooterFull";

import * as info from "./styles/info.module.scss";
const TaxInfo = () => {
  return (
    <section className={info.info}>
      <div className="container">
        <HeaderLogoAndTel/>
        <p className={info.info__txt}>
          Получить налоговый вычет при покупке курсов можно в случае, если договор заключен с ООО&nbsp;Адванс и оплата произведена на ООО&nbsp;Адванс. Вычет могут получить налоговые резиденты&nbsp;РФ, которые работают на территории&nbsp;РФ, платят НДФЛ по ставке 13% и осуществили оплату в любой форме, кроме:
        </p>
        <ul className={info.info__list}>
          <li className={info.info__item}>
            Оплаты по счету от юридического лица
          </li>
          <li className={info.info__item}>
            Оплаты материнским капиталом
          </li>
          <li className={info.info__item}>
            Оплаты через PayPal
          </li>
          <li className={info.info__item}>
            Оплаты по кредитному договору с банком Тинькофф до&nbsp;17.06.2021 года
          </li>
        </ul>

        <p className={info.info__txtSeparate}>
          Также невозможно получить вычет за онлайн-обучение ребенка, опекаемого, родственника, но если Вы — родитель, родственник или опекун обучающегося, то мы можем указать Вас как студента курса, и Вы получите вычет как обучающийся.
        </p>

        <p className={info.info__txt}>
          Необходимый комплект документов для подачи на налоговый вычет:
        </p>
        <ul className={info.info__list}>
          <li className={info.info__item}>
            Чек. Он должен был прийти вам на почту после оплаты
          </li>
          <li className={info.info__item}>
            Копия договора на обучение с приложениями и доп. соглашениями к нему
          </li>
          <li className={info.info__item}>
            Копия документа, подтверждающего оплату обучения. Например, квитанция к приходному кассовому ордеру, платёжное поручение
          </li>
          <li className={info.info__item}>
            Копия лицензии образовательной организации, если она не указана в договоре
          </li>
        </ul>

        <p className={info.info__txtSeparate}>
          Для получения договора и копии лицензии Вам нужно написать нам на электронный адрес <a href={"mailto:service@advance.ru"} className={info.info__link}>service@advance.ru</a>, указав номер заказа или почту, на которую оформляли заказ, и название курса, а также ФИО и контактный телефон.
        </p>

        <p className={info.info__txt}>
          КАКИЕ ДОКУМЕНТЫ ПРЕДОСТАВЛЯЕТ ООО&nbsp;Адванс:
        </p>
        <ul className={info.info__list}>
          <li className={info.info__item}>
            Договор или договор оферты
          </li>
          <li className={info.info__item}>
            Копию выписки из реестра лицензий или лицензию
          </li>
        </ul>
        <p className={info.info__txt}>
          Перечень документов зависит от даты и способа оплаты.
        </p>

        <p className={info.info__txtSeparate}>
          ООО Адванс не предоставляет платежные документы. Кассовые чеки и квитанции при оплате через платежных операторов (Юкасса, Яндекс касса, Клаудпейментс, Джастклик, Пэйпал) формирует и отправляет на Вашу почту при оплате платежный сервис. Дополнительные товарные накладные, счета-фактуры, квитанции, письма, справки, чеки не оформляются. Квитанция и чек от оператора платежа приходят на Вашу почту в день оплаты. Также Вы можете запросить квитанцию у банка или дубликат в платежном сервисе.
        </p>

        <p className={info.info__txtSeparate}>
          Обращаем Ваше внимание, что максимальный размер налогового вычета составляет 120&nbsp;000 рублей. Так, если Вы уже получили вычет в размере 100&nbsp;000 рублей, то с текущего платежа сможете получить только оставшиеся 20&nbsp;000 рублей. Аналогично, если вы получите вычет за обучение в размере 50&nbsp;000 рублей, то сумма остальных вычетов не сможет превышать 70&nbsp;000 рублей.
        </p>
      </div>
    </section>
  );
};

const TITLE = 'Как получить налоговый вычет 13% при покупке курсов Advance';
export const Head = () => (
  <Seo title={TITLE}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <TaxInfo/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);

export default Page;
